import script from "./My.vue?vue&type=script&setup=true&lang=js"
export * from "./My.vue?vue&type=script&setup=true&lang=js"

import "./My.vue?vue&type=style&index=0&id=f264614a&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f264614a"]])

export default __exports__